import { string, shape } from "prop-types";

const RoomBookExportShape = shape({
  id: string,
  label: string
});

export default RoomBookExportShape;
